<div class="container" style="margin-top: 32px;">
  <h2>Course Content?</h2>
  <ul class="list-group">
    <li href="#" *ngFor="let lesson of lessons; let i = index"
       class="list-group-item list-group-item-action"><span style="margin-right: 15px;">{{i + 1}}.</span>{{lesson.title}}</li>
  </ul>
</div>
